<template>
  <div class="summary pt-3 pb-1 px-3">
    <div class="summary__pricing">
      <span class="summary__pricing-title">Total</span>
      <div class="d-flex flex-column align-items-end">
        <span class="summary__pricing-total mb-2">
          {{ total }}
        </span>
        <span v-if="isTaxLabelVisible" class="summary__pricing-hint mt-1">
          Tax calculated at checkout
        </span>
      </div>
    </div>
    <div class="summary__checkout-button">
      <Button
        id="Checkout_basket_sticky"
        class="mt-3 mb-3"
        full-width
        :loading="loading"
        @click="$emit('handleProceedToCheckoutClick')"
      >
        Go to checkout
      </Button>
      <payment-icons variant="basket" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Elements/Button';
import PaymentIcons from '@/components/PaymentIcons/PaymentIcons.vue';

export default {
  name: 'StickyCheckoutSummary',

  components: {
    Button,
    PaymentIcons
  },

  props: {
    total: {
      type: String,
      default: ''
    },
    isTaxLabelVisible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.summary {
  position: fixed;
  display: flex;
  flex-direction: column;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: $light-grey-color;
  box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.16);
  max-width: 100vw;

  @media screen and (min-width: $screen-width-lg) {
    display: none;
  }

  &__checkout-button {
    .payment-icons {
      max-width: 340px;
    }
  }

  &__pricing {
    display: flex;
    justify-content: space-between;

    &-title {
      font-size: 32px;
      line-height: 24px;
      color: $dark-color;
      text-transform: uppercase;
      font-family: 'Poppins-SemiBold', sans-serif;
    }

    &-total {
      font-size: 32px;
      line-height: 24px;
      color: $dark-color;
      font-family: 'Poppins-SemiBold', sans-serif;
    }

    &-hint {
      font-size: 13px;
      color: $grey-color;
      line-height: 13px;
    }
  }
}
</style>
